import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
}));

const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
  '--scroll-thumb': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.18 : 0.3),
  '--scroll-thumb-hover': alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.28 : 0.45),
  maxHeight: '100%',
  scrollbarWidth: 'thin',
  scrollbarColor: 'var(--scroll-thumb) transparent',
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: 'var(--scroll-thumb)',
    },
    '&.simplebar-visible:before': {
      opacity: 1,
    },
    '&:hover:before': {
      backgroundColor: 'var(--scroll-thumb-hover)',
    },
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 8,
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 8,
  },
  '& .simplebar-mask': {
    zIndex: 'inherit',
  },
}));

// ----------------------------------------------------------------------

Scrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default function Scrollbar({ children, sx, ...other }) {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (isMobile) {
    return (
      <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <RootStyle>
      <SimpleBarStyle timeout={500} clickOnTrack={false} sx={sx} {...other}>
        {children}
      </SimpleBarStyle>
    </RootStyle>
  );
}
